import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    // Redirect empty path to '/example'
    {path: '', pathMatch : 'full', redirectTo: 'sign-in'},

    // Redirect signed-in user to the '/example'
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    {path: 'signed-in-redirect', pathMatch : 'full', redirectTo: 'sign-in'},

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'confirmation-required', loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.routes')},
            {path: 'forgot-password', loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.routes')},
            {path: 'reset-password', loadChildren: () => import('app/modules/auth/reset-password/reset-password.routes')},
            {path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.routes')},
            {path: 'redirect', loadChildren: () => import('app/modules/auth/redirect/redirect.routes')},
            {path: 'sign-up', loadChildren: () => import('app/modules/auth/sign-up/sign-up.routes')},
            {path: 'sign-in-mobile', loadChildren: () => import('app/modules/auth/sign-in-mobile/sign-in-mobile.routes')}
        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.routes')},
            {path: 'unlock-session', loadChildren: () => import('app/modules/auth/unlock-session/unlock-session.routes')}
        ]
    },

    // Landing routes
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'home', loadChildren: () => import('app/modules/landing/home/home.routes')},
        ]
    },

    // Admin routes
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        children: [
            {path: 'example', loadChildren: () => import('app/modules/admin/example/example.routes')},
            {path: 'dealer-dashboard', loadChildren: () => import('app/modules/admin/dashboard/dashboard.routes')},
            {path: 'dealer-retail-outlets', loadChildren: () => import('app/modules/admin/retail-outlets/retail-outlets.routes')},
            {path: 'dealer-du-transactions', loadChildren: () => import('app/modules/admin/transactions/transactions.routes')},
            {path: 'dealer-pricing', loadChildren: () => import('app/modules/admin/pricing/pricing.routes')},
            {path: 'dealer-interlocks', loadChildren: () => import('app/modules/admin/interlock/interlocks.routes')},
            {path: 'dealer-users', loadChildren: () => import('app/modules/admin/users/users.routes')},
            {path: 'dealer-alerts', loadChildren: () => import('app/modules/admin/alerts/alerts.routes')},
            {path: 'dealer-preset-transaction', loadChildren: () => import('app/modules/admin/preset-transaction/preset-transaction.routes')},
            {path: 'dealer-density-register', loadChildren: () => import('app/modules/admin/density-register/density-register.routes')},
            {path: 'dealer-shifts', loadChildren: () => import('app/modules/admin/shifts/shifts.routes')},
            {path: 'dealer-shift-reports', loadChildren: () => import('app/modules/admin/shift-reports/shift-reports.routes')},
            {path: 'dealer-sales', loadChildren: () => import('app/modules/admin/sales/sales.routes')},
            {path: 'dealer-roles', loadChildren: () => import('app/modules/admin/roles/roles.routes')},
            {path: 'dealer-report', loadChildren: () => import('app/modules/admin/dealer-report/dealer-report.routes')},
            {path: 'territory-report', loadChildren: () => import('app/modules/admin/territory-report/territory-report.routes')},
            {path: 'decantation', loadChildren: () => import('app/modules/admin/decantation/decantation.routes')},
            {path: 'audit', loadChildren: () => import('app/modules/admin/audit/audit.routes')},
            {path: 'knowledge-center', loadChildren: () => import('app/modules/admin/knowledge-center/knowledge-center.routes')},
            {path: 'checklist', loadChildren: () => import('app/modules/admin/checklist/checklist.routes')},
            {path: 'assessment', loadChildren: () => import('app/modules/admin/assessment/assessment.routes')},
            {path: 'assessments', loadChildren: () => import('app/modules/admin/admin-assessments/admin-assessments.routes')},
            {path: 'version', loadChildren: () => import('app/modules/admin/version/version.routes')},
            {path: 'lux', loadChildren: () => import('app/modules/admin/lux/lux.routes')},
            {path: 'uptime-report', loadChildren: () => import('app/modules/admin/uptime-report/uptime-report.routes')},
            {path: 'control-records', loadChildren: () => import('app/modules/admin/control-records/control-records.routes')},
        ]
    }
];
